if (!customElements.get('faq-categories')) {
  customElements.define('faq-categories', class FaqCategories extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('[data-category].faq-categories__pill'));
      this.items = Array.from(this.querySelectorAll('.faq__list [data-category]'));
      this.empty = this.querySelector('.faq-categories__empty');
      this._onClick = this._onClick.bind(this);
      this.pills.forEach(pill => pill.addEventListener('click', this._onClick));
    }

    disconnectedCallback() {
      this.pills.forEach(pill => pill.removeEventListener('click', this._onClick));
    }

    _onClick(e) {
      this.filterCategory(e.currentTarget.dataset.category);
    }

    filterCategory(category) {
      this.pills.forEach(p => {
        const active = p.dataset.category === category;
        p.classList.toggle('faq-categories__pill--active', active);
        p.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.querySelectorAll('details[open]').forEach(d => d.removeAttribute('open'));

      let visibleCount = 0;
      this.items.forEach(item => {
        const match = category === 'all' || item.dataset.category === category;
        item.hidden = !match;
        if (match) visibleCount++;
      });

      if (this.empty) this.empty.hidden = visibleCount > 0;
    }
  });
}
